export default function CenteredContent() {
  return (
    <div className="bg-[#2a3342] px-6 pt-16 relative w-screen max-w-screen overflow-hidden">
      <div className="mx-auto max-w-4xl text-center font-['Inter']" tabIndex={0}>
        <p className="text-base font-bold text-orange-400">DISCOVER PORTALJS</p>
        <h2 className="text-center mx-auto mb-8 main-top-title text-white " style={{color: "white"}}>Our solution</h2>
      </div>
    </div>
  )
}